<script>
import { coresNomes } from '@constants/Color'

export default {
  name: 'BaseGauge',
  props: {
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    width: { type: Number, default: 150 },
    height: { type: Number, default: 95 },
    strokeWidth: { type: Number, default: 10 },
    segmentsColor: {
      type: Array,
      default: () => [
        coresNomes.verdeInvestimento,
        coresNomes.laranjaDinamico,
        coresNomes.vermelhoControle,
      ],
    },
    pointerColor: { type: String, default: 'var(--secondary)' },
  },
  computed: {
    normalizedValue() {
      const range = this.max - this.min
      if (range === 0) return 0
      const clamped = Math.min(Math.max(this.value, this.min), this.max)
      return ((clamped - this.min) / range) * 100
    },
    pointerAngle() {
      return -180 + (this.normalizedValue / 100) * 180
    },
  },
}
</script>

<template>
  <div class="base-gauge" :style="{ width: width + 'px', height: height + 'px' }">
    <svg :width="width" :height="height" class="gauge-svg" viewBox="0 0 150 95">
      <g transform="translate(75, 75)">
        <path
          d="M -45 -52 A 69 69 0 0 0 -69 0"
          fill="none"
          :stroke="segmentsColor[0]"
          :stroke-width="strokeWidth"
          stroke-linecap="round"
        />

        <path
          d="M 30 -62 A 69 69 0 0 0 -30 -62"
          fill="none"
          :stroke="segmentsColor[1]"
          :stroke-width="strokeWidth"
          stroke-linecap="round"
        />

        <path
          d="M 69 0 A 69 69 0 0 0 45 -52"
          fill="none"
          :stroke="segmentsColor[2]"
          :stroke-width="strokeWidth"
          stroke-linecap="round"
        />

        <g :transform="`rotate(${pointerAngle})`">
          <line
            x1="0"
            y1="0"
            x2="60"
            y2="0"
            :stroke="pointerColor"
            stroke-width="4"
            stroke-linecap="round"
          />
          <circle cx="0" cy="0" r="6" :fill="pointerColor" />
        </g>
      </g>
    </svg>
  </div>
</template>

<style lang="sass" scoped>
.base-gauge
  display: flex
  flex-direction: column
  align-items: center
  position: relative

  .gauge-svg
    overflow: visible
</style>
